<div id="macro-list">
    <mat-icon class="add" [ngClass]="{ 'opaque': opaque }" (click)="createOrEdit(macros.length)">add_box</mat-icon>
    <ng-container *ngFor="let macro of macros; let i = index">
        <span *ngIf="newTarget!=i" class="dicemacro" [ngClass]="{ 'opaque': opaque }" (click)="roll(macro)" (middleclick)="delete(i)" (contextmenu)="createOrEdit(i)" draggable="true" (dragstart)="dragstart($event)" (dragenter)="dragenter($event)" (dragleave)="dragleave($event)" (dragend)="dragend($event)" [attr.index]="i">{{macro}}</span>
        <input *ngIf="newTarget==i" #inputElement type="text" id="entermacro" [attr.index]="i" [(ngModel)]="macroText" autocomplete="off" />
    </ng-container>
</div>
